<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-14 10:32:27
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-20 10:00:30
-->
<template>
  <ux-form
    class="bind-access"
    ref="form"
    :colon="true"
    :data="formData"
    :rules="rules"
    label-width="90px"
    data-automation="bindAccess"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.bindAccessIp.appId')" prop="app_id">
      <ux-input
        v-model="formData.app_id"
        :placeholder="$t('HT.bindAccessIp.appId.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.bindAccessIp.addr')" prop="addr">
      <ux-input
        v-model="formData.addr"
        :placeholder="$t('HT.bindAccessIp.addr.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // id
        app_id: this.data.app_id, // 应用id
        addr: this.data.addr // ip地址
      },

      rules: this.$rul.AccessIp(this.formData)
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bind-access .ux-input {
  width: 300px;
}
</style>

